import IframeActivity from "./IframeActivity";

export default function LifeGoals() {
    return (
        <IframeActivity
            src="/activities/life-goals/index.html"
            title="Happiness Experiment"
        />
    );
}